$(document).ready(function( $ ) {
    $(window).scroll(function(){
        if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
            $('#js-scroll-to-top').fadeIn();
        } else {
            $('#js-scroll-to-top').hide();
        }
    });
});